import { render, staticRenderFns } from "./PricingPlans.vue?vue&type=template&id=b3c39df0&scoped=true"
import script from "./PricingPlans.vue?vue&type=script&lang=js"
export * from "./PricingPlans.vue?vue&type=script&lang=js"
import style0 from "./PricingPlans.vue?vue&type=style&index=0&id=b3c39df0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c39df0",
  null
  
)

export default component.exports